import { Injectable } from '@angular/core';
import {
	Router, Resolve,
	RouterStateSnapshot,
	ActivatedRouteSnapshot
} from '@angular/router';
import { NEVER, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { JobDigitalLogFormRequest } from '../models/digital-log/digital-log.model';
import { DigitalLogService } from '../services/sections/job/digital-log.service';
import { GlobalSettingsService } from '../services/ui/global-settings.service';

@Injectable({
	providedIn: 'root'
})
export class DigitalLogOnDemandFormCountResolver implements Resolve<Observable<number>> {

	constructor(
		private router: Router,
		private digitalLogService: DigitalLogService
	) { }
	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		GlobalSettingsService.isSecondaryLoaderLoading = true;
		
		return this.digitalLogService
			.countOnDemandDLForms(activatedRouteSnapshot.paramMap.get('token'), false)
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
